import React from 'react';
import Legal from './Legal';

const link = "https://docs.google.com/document/d/e/2PACX-1vRLOQ4jP83VDx98i1RNougjkxpZeMCTs2QNBIhthT8ibjsbkQvc633jfBoF2gSSqNRqDI1Uzy5VZO0U/pub?embedded=true";

export default () => {
  return (<Legal title="Privacy Policy" link={link} />);
}


// WEBPACK FOOTER //
// ./src/entries/Legal/Privacy.js